import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import LoginForm from 'components/templates/form-login';
import { ClearStateSliceActions } from 'common/config/store';
import Layout from 'components/templates/layout';
import Card from 'components/molecules/card';
import { useIntl } from 'common/config/i18n';
import { StyledFormBottomWrapper as ForgotPasswordWrapper } from 'common/styling/mixins';
import useLoginRedirection from 'hooks/use-login-redirection';

const Login: React.FC = () => {
  const { t } = useIntl();
  const dispatch = useDispatch();

  useLoginRedirection();

  const forgotPasswordClickHandler = () => {
    return dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'ResetPassword' }));
  };

  return (
    <div>
      <Layout login />
      <Card title={t('form', 'FORM_CONNECT_TITLE')}>
        <LoginForm />
        <ForgotPasswordWrapper>
          <Link to="/forgot-password" onClick={forgotPasswordClickHandler}>
            {t('form', 'FORGOT_PASSWORD_LINK')}
          </Link>
        </ForgotPasswordWrapper>
      </Card>
    </div>
  );
};
export default Login;
